import { useEffect, useRef } from "react";
import {Wrench, Briefcase, ShoppingBag, Stethoscope, UtensilsCrossed, Scissors, Building2, Dumbbell, MapPin, GraduationCap, Palette, Car} from 'lucide-react';

const segments = [
{ icon: Wrench, label: "Prestador de serviços" },
{ icon: Briefcase, label: "Profissional liberal" },
{ icon: ShoppingBag, label: "Loja física ou online", note: "(não fazemos e-commerce)" },
{ icon: Stethoscope, label: "Clínica ou consultório" },
{ icon: UtensilsCrossed, label: "Restaurante ou delivery" },
{ icon: Scissors, label: "Salão / barbearia" },
{ icon: Building2, label: "Imobiliária" },
{ icon: Dumbbell, label: "Academia ou estúdio" },
{ icon: MapPin, label: "Pequena empresa local" },
{ icon: GraduationCap, label: "Escola ou curso" },
{ icon: Palette, label: "Arquiteto ou designer" },
{ icon: Car, label: "Oficina ou autopeças" }];


export default function ParaQuem() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll(".fade-up").forEach((el) => {
              el.classList.add("visible");
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="para-quem" ref={sectionRef} className="md:py-14 bg-white pt-[20px] pb-[20px]">
      <div className="max-w-6xl mx-auto px-5">
        {/* Cabeçalho */}
        <div className="text-center max-w-2xl mx-auto mb-8">
          <div className="fade-up inline-flex items-center gap-2 bg-emerald-50 rounded-full px-4 py-1.5 mb-5">
            <span className="text-emerald-600 text-xs font-semibold tracking-wide uppercase">
              Para você
            </span>
          </div>
          <h2 className="fade-up fade-up-delay-1 text-3xl md:text-5xl font-bold text-gray-900 leading-tight text-balance">
            Se você é… este serviço é para você
          </h2>
          <p className="fade-up fade-up-delay-2 text-gray-500 text-base md:text-lg mt-4">
            Atendemos diversos segmentos com sites sob medida.
          </p>
        </div>

        {/* Grid de segmentos — 12 itens em grid uniforme */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {segments.map((seg, i) =>
          <div
            key={seg.label}
            className={`fade-up fade-up-delay-${Math.min(i % 4 + 1, 5)} group flex flex-col items-center gap-3 bg-gray-50 hover:bg-gradient-to-br hover:from-blue-50 hover:to-emerald-50 border border-gray-100 hover:border-blue-200 rounded-2xl p-6 transition-all duration-300 hover:shadow-lg hover:shadow-blue-100/30 hover:-translate-y-1 cursor-default`}>

              <div className="w-12 h-12 rounded-xl bg-white shadow-sm flex items-center justify-center text-gray-400 group-hover:text-blue-600 transition-colors">
                <seg.icon className="w-6 h-6" />
              </div>
              <div className="text-center">
                <span className="text-sm font-semibold text-gray-700 leading-snug block">
                  {seg.label}
                </span>
                {seg.note &&
              <span className="text-xs text-gray-400 mt-1 block">{seg.note}</span>
              }
              </div>
            </div>
          )}
        </div>

        {/* Frase de fechamento */}
        <div className="fade-up mt-8 text-center">
          <div className="inline-flex items-center gap-3 bg-gradient-to-r from-emerald-50 to-blue-50 border border-emerald-100 rounded-2xl px-8 py-5">
            <span className="text-2xl">🚀</span>
            <p className="text-gray-700 font-semibold text-base md:text-lg">
              Se você vende algo, um site ajuda você a vender mais.
            </p>
          </div>
        </div>
      </div>
    </section>);

}